import React from 'react';
import {
  AppBar as MuiAppBar,
  Toolbar,
  IconButton,
  Box,
  Typography,
  useMediaQuery,
  Theme,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  Menu as MenuIcon,
  ArrowBackIos as ArrowBackIosIcon,
} from '@material-ui/icons';

import config from '../../config';
import styles from './AppBar.styles';
import { SidePanelDispatchFunc } from '../sidePanel/types';

type Props = {
  title?: string;
  menuStatus?: 'collapse' | 'extend';
  extendMenu: SidePanelDispatchFunc<unknown>;
  collapseMenu: SidePanelDispatchFunc<unknown>;
  children?: JSX.Element | JSX.Element[],
};

const useStyles = makeStyles(styles);

const AppBar: React.FC<Props> = ({
  title,
  menuStatus,
  extendMenu,
  collapseMenu,
  children,
}: Props) => {
  const classes = useStyles();
  const isMediumScreen = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  const actionMenu = () => {
    if (menuStatus === 'collapse') {
      extendMenu();
    } else {
      collapseMenu();
    }
  };

  return (
    <MuiAppBar
      position="static"
      classes={{
        root: classes.root,
      }}
    >
      <Toolbar
        variant="dense"
        classes={{
          gutters: classes.toolBar,
        }}
      >
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          classes={{
            root: classes.sideBarButton,
          }}
          onClick={() => { actionMenu(); }}
        >
          {menuStatus === 'collapse' ? <MenuIcon /> : <ArrowBackIosIcon />}
        </IconButton>
        {isMediumScreen && (
          <Box className={classes.titleContainer}>
            <img
              src={`${config.routerBase}/logo.png`}
              alt="Lab Connect "
              className={classes.logo}
            />
          </Box>
        )}
        {title && (
          <Typography
            classes={{
              body1: classes.title,
            }}
            variant="body1"
          >
            {`${title}`}
          </Typography>
        )}
        <Box className={classes.subComponents}>
          {children}
        </Box>
      </Toolbar>
    </MuiAppBar>
  );
};

export default AppBar;
